<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol md=12>
        <MetaSection>
          <div class="text-right">
            <argon-button :to="{ name: 'Hak Akses Create' }" :isRouteLink="true"><font-awesome-icon icon="fa-solid fa-plus" /> Tambah Hak Akses</argon-button>
          </div>
        </MetaSection>
      </GridCol>
      <GridCol md="12">
        <CardComponent :useHeader="true">
          <template v-slot:header-action>
            <GridRow class="w-100">
              <GridCol md="12">
                <div class="pe-md-3 d-flex align-items-center w-50">
                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="getData(params.keyword)" type="text" class="form-control"
                      placeholder="Cari hak akses..." style="border-right: 1px solid #d2d6da!important;">
                  </InputGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>
          <ListView :thead="['Nama Hak Akses', 'Keterangan', 'Label', 'Status', 'Aksi']">
            <template v-slot:tbody>
              <tr v-if="data.length < 1">
                <td colspan="5" class="text-center text-secondary">Tidak ada data</td>
              </tr>
              <tr v-for="(item, index) in data" :key="index">
                <td class="font-weight-bold">{{ item.name ?? "" }}</td>
                <td>{{ item.description ?? "" }}</td>
                <td>
                  <argon-badge v-if="item.label" color="secondary">{{ item.label ?? "" }}</argon-badge>
                </td>
                <td>
                  <argon-badge v-if="item.status==1" color="success">Aktif</argon-badge>
                  <argon-badge v-if="item.status==0" color="danger">Non Aktif</argon-badge>
                </td>
                <td class="align-middle">
                  <ThreeDotsMenu>
                    <router-link :to="{ name: 'Hak Akses Edit', params: { id: item?.id ?? 0 } }"
                                 class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                                 data-original-title="Edit user">Edit</router-link>
                    <button @click.prevent="deleteData(item.id)" class="text-secondary font-weight-bold text-xs btn btn-link"
                            role="link" data-toggle="tooltip" data-original-title="Delete user">Hapus</button>
                  </ThreeDotsMenu>
                </td>
              </tr>
            </template>
          </ListView>
          <ArgonPagination style="position: absolute;bottom: 0;left: 0;right: 0;" :page="params.page" :total_page="metaData.total_page" :current_page="metaData.current_page" @changepage="changePage" @changelimit="changeLimit" />
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import HakAksesApi from '@/repository/api/HakAksesApi';
import ArgonBadge from '@/components/ArgonBadge.vue';
import ArgonButton from '@/components/ArgonButton.vue';
import ArgonPagination from '@/components/ArgonPagination.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import ListView from "@/components/ListView.vue";
export default {
  name: "tables",
  components: {
    ListView,
    ArgonButton,
    CardComponent,
    InputGroup,
    ArgonBadge,
    ArgonPagination,
    ThreeDotsMenu,
    MetaSection,
    GridRow,
    GridCol,
  },
  data() {
    return {
      timer: undefined,
      data: [],
      // keyword: "",
      metaData: {},
      params: {
        limit: "10",
        keyword: "",
        page: 1,
      },
    };
  },
  watch: {
    'params.limit': {
      handler: async function () {
        this.params.page = 1
        await this.getData();
      },
      deep: false,
    },
    'params.page': {
      handler: async function (newVal, oldVal) {
        if (newVal < 1) {
          this.params.page = oldVal
        }
        else {
          await this.getData();
        }
      },
      deep: false,
    },
  },
  async mounted() {
    await this.getData();
  },
  methods: {
    async getData(keyword = "") {
      clearTimeout(this.timer)
      if (keyword.length <= 0) {
        await this.getDataAll();
      }
      else if (keyword.length >= 2) {
        this.timer = setTimeout(async () => {
          // await HakAksesApi.getByKeyword(keyword)
          await HakAksesApi.getbyparam(this.params)
            .then((response) => {
              this.data = response.data;
            }).catch(() => {
              this.data = [];
            });
        }, 1500)
      }
    },
    changeLimit(limit) {
      this.params.limit = limit
    },
    changePage(page) {
      this.params.page = page
    },
    async getDataAll() {
      this.$store.state.loading = true;
      // await HakAksesApi.get()
      await HakAksesApi.getbyparam(this.params)
        .then((response) => {
          this.data = response.data;
          this.metaData = {
            status: response?.status ?? null,
            message: response?.message ?? null,
            total_item: response?.total_item ?? null,
            per_page: response?.per_page ?? null,
            total_page: response?.total_page ?? null,
            current_page: response?.current_page ?? null,
          };
        }).catch(() => {
          this.data = [];
          this.metaData = {};
        });
      this.$store.state.loading = false;
    },
    async deleteData(id) {
      this.$swal({
        icon: "warning",
        title: "Apakah anda yakin ingin menghapus?",
        showCancelButton: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          await HakAksesApi.delete(id).then(() => {
            this.getData();
            this.$swal({
              icon: "success",
              title: "Berhasil"
            });
          }).catch((error) => {
            this.$swal({
              icon: "error",
              title: "Error",
              text: error.response.data.message,
            });
          });
          this.$store.state.loading = false;
        }
      })
    }
  },
};
</script>
